require('../bootstrap');
window.PhotoSwipe = require('photoswipe');
require('./main');
